
<template>
  <el-dialog :visible.sync="visible" center :show-close="false" :before-close="handleCancel"
             custom-class="popupBox">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{$t('termBankV2.upload')}}</slot>
      <div class="title-right"></div>
    </div>
    <el-upload class="upload-demo" drag action :limit="20" :on-exceed="handleExceed"
               :on-progress="uploadFileProcess" :show-file-list="false" accept=".docx"
               :http-request="uploadSectionFile" :before-upload="beforeUploadFile"
               :file-list="fileList" :on-change="uploadChange" multiple>
      <div v-if="fileList.length === 0" class="uploadImg">
        <img style="margin-top:25px;color:#999999;"
             src="../../assets/images/update_bg_pic_upload.png" alt />
        <br>
        <el-button class="uploadebtn">{{$t('termBankV2.clickUpload')}}</el-button>
        <div style="margin-top:5px;">{{$t('termBankV2.clickUploadFile')}}</div>
        <div style="margin-bottom: 5px; line-height: 10px;">
          <em>{{$t('termBankV2.onlyDocx')}}</em>
        </div>
      </div>
      <div v-if="fileList.length > 0" class="msgTable">
        <el-table :data="fileList" border style="width: 100%" height="100%" :header-cell-style="{
              backgroundColor: '#E4EDFC',
              'text-align': 'center',

            }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column type="index" align="center" :label="$t('termBankV2.number')"
                           width="50" />
          <el-table-column prop="name" align="center" :label="$t('termBankV2.name')" min-width="100"
                           show-overflow-tooltip />
          <el-table-column :label="$t('termBankV2.uploadState')" min-width="80">

            <template slot-scope="scope">
              <img :src="isSrc(scope.row)" alt />
            </template>
          </el-table-column>
          <el-table-column :label="$t('termBankV2.operation')" min-width="40">
            <template slot-scope="scope">

              <el-tooltip class="item" effect="dark" :content="$t('termBankV2.delete')"
                          placement="bottom">
                <!-- <i class="el-icon-delete" @click.stop="handleDelete(scope.$index, scope.row)"></i> -->
                <img :src="deleteImgSrc" @click.stop="handleDelete(scope.$index, scope.row)" alt>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{$t('termBankV2.cancel')}}</el-button>
      <el-button v-preventReClick type="primary" @click="handleSure">{{$t('termBankV2.confirm')}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { filterSize } from "@/services/common";
import { getUploadSign } from "@/services/newProjectApi";
import DialogsHeader from '@/common/dialogsHeader';
export default {
  name: "taskUpload",
  props: ["visible", "taskInfo"],
  data() {
    return {
      fileList: [], //文件列表
      fileName: null,
      host: "",
      formData: new FormData(),

      fileUrl: "/api/v1/memory/checkFileContent",
      imgSrc: require("./assets/images/uploadfail.png"),
      succeedImgSrc: require("./assets/images/uploadsuccess.png"),
      deleteImgSrc: require("./assets/images/delete.png"),//删除
      ruleForm: {
        sentFileUrlList: [],
        id: null,
      },
    };
  },
  components: {
    DialogsHeader
  },
  created() { },

  mounted() { },

  methods: {
    //取消弹窗
    handleCancel() {
      this.fileList = [];
      this.$emit("handleCancel", false);
    },
    //超过文件数提示
    handleExceed() {
      this.$message.closeAll();
      this.$message({
        message: this.$t("myTaskV2.maxFileNum", [1]),
        type: "warning",
      });
    },

    //自定义上传开始
    uploadSectionFile(param) {
      console.log("555")
      let self = this;
      // 获得上传签名
      getUploadSign()
        .then(({ result }) => {
          // 上传地址
          this.host = result.host;

          let re = /([^\.\/\\]+)\.([a-z]+)$/i;
          let resultArr = re.exec(param.file.name);
          // 文件类型
          let type = resultArr[2].toLocaleLowerCase();
          // let para = {
          //   key: `${result.keyPrefix}.${type}`,
          //   sign: result.sign,
          //   ts: result.ts,
          //   token: result.token,
          //   file: param.file,
          // };
          let para = {
            ...result,
            key: `${result.keyPrefix}.${type}`,
            file: param.file,
          };
          Reflect.deleteProperty(para, 'keyPrefix');
          Reflect.deleteProperty(para, 'host');
          console.log(para)
          self.formData = new FormData();
          Object.keys(para).forEach(function (key) {
            self.formData.append(key, para[key]);
          });

          this.getFileHost(param);
        })
        .catch(() => {
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
          this.$message({
            message: this.$t("myTaskV2.uploadFileError"),
            type: "warning",
          });
        });
    },

    //上传接口
    getFileHost(param) {
      let self = this;
      let FileController = self.host;

      let config = {
        onUploadProgress: (progressEvent) => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        },
      };
      axios
        .post(FileController, self.formData, config)
        .then((resp) => {
          if (resp) {
            let result = resp.data.result;
            this.fileName = result.fileName;
          } else {
            return false;
          }
        })
        .catch(function () {
          self.fileList.forEach((item) => {
            if (item.name === param.file.name) {
              item.percentage = 0;
            }
          });
        });
    },
    // 检测文件编码
    getFileContent(path, param) {
      var that = this;
      this.catReq1Service(this.fileUrl, {
        fileUrlList: [path],
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;

        if (data.status === 0) {
          that.$message.closeAll();
          that.$message({
            message: data.reason,
            type: "error",
          });
        }
        that.fileList.forEach((item) => {
          if (item.uid === param.file.uid) {
            if (data.status === 0) {
              item.percentage = -1;
            } else {
              that.ruleForm.sentFileUrlList.push(path);
            }
          }
        });
      });
    },

    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {
      var that = this;
      let type = this.typeReg(file.name); // 拿到文件后缀
      file.obp = true;

      this.fileList.slice(0, -1).forEach((item) => {
        if (item.name === file.name) {
          this.fileList.pop();
          this.$message({
            // message: "上传文件名称重复!",
            message: that.$t("myTaskV2.uploadFileRepeat") + "!",
            type: "warning",
          });
          file.obp = false;
          return false;
        }
      });
      const isDOCX = type === "docx";
      // const isTXT = type === "txt";
      // const isXLSX = type === "xlsx";
      // const isTMX = type === that.myTemplate;
      // const isZip = type === "zip";
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isDOCX) {
        this.$message.closeAll();
        this.$message({
          // 仅支持docx文件
          message: this.$t("myTaskV2.onlyDocx"),
          type: "warning",
        });
        file.obp = false;
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          // message: "不支持上传空文件",
          message: that.$t("myTaskV2.uploadFileContentEmpty"),
          type: "warning",
        });
        return false;
      }
      if (!isLt50M) {
        this.$message.closeAll();
        that.$message({
          // message: "上传文件大小不能超过 50MB!",
          message: that.$t("myTaskV2.uploadFileSize", [50]),
          type: "warning",
        });
        file.obp = false;
        return false;
      }
      return isDOCX && isLt50M;
    },

    uploadChange: function (event, file, fileList) {
      this.fileList = file;
    },

    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      fileList.forEach((item) => {
        if (parseInt(item.percentage) === 100) {
        } else {
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      });
    },
    //删除文件
    handleDelete(index, rows) {
      let that = this;
      that.fileList.splice(index, 1);
      that.ruleForm.sentFileUrlList.splice(index, 1);
    },
    isSrc(row) {
      if (row.percentage === 100) {
        return this.succeedImgSrc;
      } else if (row.percentage === -1) {
        return this.imgSrc;
      } else {
        return require("./assets/images/uploading.png");
      }
    },
    //确定将文件和任务绑定
    handleSure: function () {
      if (!!this.fileList.length) {
        const self = this;
        let url = `/api/v1/file/outLineEditUpload?fileId=${self.taskInfo.fileId}&taskId=${self.taskInfo.taskId}&fileName=${self.fileName}`;
        self.taskUpload(url, {}, "get")
          .then((resp) => {
            if (resp.success) {
              this.$message.closeAll();
              this.$message.success(this.$t("myTaskV2.uploadFileSuccess"));
              this.fileList = [];
              this.$emit("handleCancel", false);
            } else {
              self.fileList.forEach((item) => {
                item.percentage = -1;
              });
              this.this.$message.closeAll();
              this.$message({
                message: this.$t("myTaskV2.formatisIncorrect"),
                type: "error",
              });
            }
          })
          .catch(() => {
            this.$message.closeAll();
            this.$message({
              message: this.$t("myTaskV2.isIncorrect"),
              type: "error",
            });
          });
      } else {
        this.$message.closeAll();
        this.$message({
          message: this.$t("myTaskV2.pleaseUpload"),
          type: "warning",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>